/* src/app/features/purchase-requests/supplier-selection/supplier-binding/supplier-binding.component.css */
/*# sourceMappingURL=supplier-binding.component.css.map */
